<template>
  <div class="relative">
    <img
      :src="imageUrl"
      class="antialiased bg-black bg-cover rounded-full athlete-avatar"
      :class="[isLoggedOut ? 'block md:mx-auto' : '']"
      v-if="hasImage && !imageError"
      :style="imageStyles"
      :alt="`${firstName} ${lastName}`"
      @error="handleImageError"
    />
    <DefaultAvatar
      :firstName="firstName"
      :lastName="lastName"
      :size="size"
      :isLoggedOut="isLoggedOut"
      :bgColor="bgColor"
      v-else
    />
    <div
      v-if="verified"
      class="absolute bottom-0 rounded-full border-white border-solid border-3 bg-white flex justify-center items-center"
      style="right: -0.25rem"
    >
      <VerifiedBadge
        :position="verifiedTooltipPosition"
        :size="verifiedBadgeSize"
      />
    </div>
  </div>
</template>

<script>
import DefaultAvatar from "@/components/DefaultAvatar";
import VerifiedBadge from "@/components/Verification/VerifiedBadge"

export default {
  components: {
    DefaultAvatar,
    VerifiedBadge,
  },
  props: {
    firstName: { type: String, required: false, default: "" },
    lastName: { type: String, required: false, default: "" },
    size: { type: String | Number, default: 16 },
    imageUrl: { type: String, required: false, default: null },
    isLoggedOut: { type: Boolean, default: true },
    bgColor: { type: String, required: false, default: "" },
    verified: { type: Boolean, required: false, default: false },
    showVerifiedModal: { type: Boolean, required: false, default: true },
    verifiedTooltipPosition: { type: String, required: false, default: "top" },
  },
  data() {
    return {
      imageError: false
    };
  },
  computed: {
    imageStyles: function () {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`
      };
    },
    hasImage() {
      return !!this.imageUrl;
    },
    verifiedBadgeSize() {
      return {
        32: "sm",
        48: "base",
        64: "lg",
      }[this.size];
    },
  },

  methods: {
    handleImageError() {
      this.imageError = true;
    },
  },
};
</script>

<style scoped>
</style>
